<form [formGroup]="caseSettingForm" id="caseSettingForm">
    <!-- Ayarlar Başlığı -->
    <h5 class="fw-bold mb-4">{{ 'settings' | translate }}</h5>

    <div class="mb-8">
        <label class="form-label fw-bold mb-2">
            {{ "hypoglycemiaThreshold" | translate }} mg/dl
        </label>
        <input type="number" class="form-control" [formControlName]="'hypoglycemiaThreshold'"
            placeholder="{{ 'hypoglycemiaThreshold' | translate }}" />
        <div *ngIf="isControlInvalid('hypoglycemiaThreshold')" class="text-danger mt-2">
            {{ "fieldRequired" | translate }}
        </div>
    </div>

    <div class="mb-8">
        <label class="form-label fw-bold mb-2">
            {{ "fastingGlucoseThreshold" | translate }} mg/dl
        </label>
        <input type="number" class="form-control" [formControlName]="'fastingGlucoseThreshold'"
            placeholder="{{ 'fastingGlucoseThreshold' | translate }}" />
        <div *ngIf="isControlInvalid('fastingGlucoseThreshold')" class="text-danger mt-2">
            {{ "fieldRequired" | translate }}
        </div>
    </div>

    <div class="mb-8">
        <label class="form-label fw-bold mb-2">
            {{ "postprandialGlucoseThreshold" | translate }} mg/dl
        </label>
        <input type="number" class="form-control" [formControlName]="'postprandialGlucoseThreshold'"
            placeholder="{{ 'postprandialGlucoseThreshold' | translate }}" />
        <div *ngIf="isControlInvalid('postprandialGlucoseThreshold')" class="text-danger mt-2">
            {{ "fieldRequired" | translate }}
        </div>
    </div>

    <div class="mb-8">
        <label class="form-label fw-bold mb-2">
            {{ "hba1cThreshold" | translate }} %
        </label>
        <input type="number" class="form-control" [formControlName]="'hba1cThreshold'"
            placeholder="{{ 'hba1cThreshold' | translate }}" />
        <div *ngIf="isControlInvalid('hba1cThreshold')" class="text-danger mt-2">
            {{ "fieldRequired" | translate }}
        </div>
    </div>

    <!-- Takip Başlığı -->
    <h5 class="fw-bold mt-5 mb-4">{{ 'followUp' | translate }}</h5>

    <div class="mb-8">
        <label class="form-label fw-bold mb-2">
            {{ "followUpDurationDays" | translate }}
        </label>
        <input type="number" class="form-control" [formControlName]="'followUpDurationDays'"
            placeholder="{{ 'followUpDurationDays' | translate }}" />
        <div *ngIf="isControlInvalid('followUpDurationDays')" class="text-danger mt-2">
            {{ "fieldRequired" | translate }}
        </div>
    </div>

    <div class="form-check mb-8">
        <input class="form-check-input" type="checkbox" [formControlName]="'disableNotificationsAfterFollowUp'"
            id="disableNotificationsAfterFollowUp" />
        <label class="form-check-label" for="disableNotificationsAfterFollowUp">
            {{ "disableNotificationsAfterFollowUp" | translate }}
        </label>
    </div>

    <!-- Save Button -->
    <!-- <div class="text-end mt-5">
        <button (click)="savePreparation($event)" type="button" class="btn btn-sm btn-primary cursor-pointer">
            {{ "save" | translate }}
        </button>
    </div> -->

    <!-- Next Step Button -->
    <div class="text-end">
        <button (click)="goToNextStep()" type="submit" class="btn btn-sm btn-primary cursor-pointer">
            {{ "nextStep" | translate }}
        </button>
    </div>
</form>